import baseConfig, { Config } from "../../utils/config";

// Visual query demo - venetian
const federalRealtyConfig: Config = {
  ...baseConfig,
  AppName: "CADViewer Visual Query: Federal Realty",
  initFileName: "", //"/content/demo_user/architectural-plan.dwg",
  ServerBackEndUrl: "https://server.ai.cadviewer.com", // "https://server.demo.cadviewer.com", //"http"http://localhost:3000"://localhost:3000", //"https://server.demo.cadviewer.com", //"https://server.demo.cadviewer.com", //"https://cadviewer-conversion-server-webapp-01.azurewebsites.net/", //"http://localhost:3000", //, //"http://localhost:3000", //"https://cadviewer-conversion-server-webapp-01.azurewebsites.net/", //"http://restapi.cadviewer.com:3000/", // "https://cadviewer-conversion-server-webapp-01.azurewebsites.net/", //"http://restapi.cadviewer.com:3000/", //"http://localhost:3000/", //"https://restapi.cadviewer.com:3000/", //"https://cadviewer-conversion-server-webapp-01.azurewebsites.net/", //"https://restapi.cadviewer.com:3000", //"https://cadviewer-conversion-server-webapp-01.azurewebsites.net/" , //"https://127.0.0.1:3000",  //"http://localhost:3000", //"https://cadviewer-conversion-server-webapp-01.azurewebsites.net/", //"http://localhost:3000",          //""http://localhost:3000",  //"https://cadviewer-conversion-server-webapp-01.azurewebsites.net/",           // This is the URL of the CADViewer back-end server
  //ServerBackEndUrl: "http://localhost:3000", // "https://server.demo.cadviewer.com", //"http"http://localhost:3000"://localhost:3000", //"https://server.demo.cadviewer.com", //"https://server.demo.cadviewer.com", //"https://cadviewer-conversion-server-webapp-01.azurewebsites.net/", //"http://localhost:3000", //, //"http://localhost:3000", //"https://cadviewer-conversion-server-webapp-01.azurewebsites.net/", //"http://restapi.cadviewer.com:3000/", // "https://cadviewer-conversion-server-webapp-01.azurewebsites.net/", //"http://restapi.cadviewer.com:3000/", //"http://localhost:3000/", //"https://restapi.cadviewer.com:3000/", //"https://cadviewer-conversion-server-webapp-01.azurewebsites.net/", //"https://restapi.cadviewer.com:3000", //"https://cadviewer-conversion-server-webapp-01.azurewebsites.net/" , //"https://127.0.0.1:3000",  //"http://localhost:3000", //"https://cadviewer-conversion-server-webapp-01.azurewebsites.net/", //"http://localhost:3000",          //""http://localhost:3000",  //"https://cadviewer-conversion-server-webapp-01.azurewebsites.net/",           // This is the URL of the CADViewer back-end server
  ServerLocation: "", // leave blank  in most cases
  ServerUrl: "http://federalrealty.cadviewer.com", //"http://vizquery.cadviewer.com", //"https://demo.cadviewer.com", //"http://localhost:3001", //"https://demo.cadviewer.com/", // "http:localhost:3001", / this is the URL of the front end server
  //ServerUrl: "http://localhost:3001", //, //"https://demo.cadviewer.com", //"http://localhost:3001", //"https://demo.cadviewer.com/", // "http:localhost:3001", / this is the URL of the front end server
  DisplayCoordinatesMenu: false, // display the CADViewer coordinates menu
  displayTopNavigationBar: false, // display the layout /model space navigation menu
  setSpaceObjectsCustomMenu: false, // display the SpaceObject Navigation menu
  hideLeftHamburgerMenu: false, // hide the left hamburger menu
  CADViewerPublicDemo: false,
  BaseAttributes: {
    fill: "#ffd7f4", //'#D3D300', // '#ffd7f4', // '#FFF' , //  '#D3D300', // #D3D3D3  // #FFF   #ffd7f4
    "fill-opacity": 0.0, // 0.1
    stroke: "#CCC",
    "stroke-width": 0.1,
    "stroke-linejoin": "round",
    "stroke-opacity": 1.0,
  },
  /*  HighlightAttributes: {
      fill: "#a4d7f4",
      "fill-opacity": 0.5,
      stroke: "#a4d7f4",
      "stroke-width": 0.2,
      "stroke-linejoin": "round",
      "stroke-opacity": 1.0,
    },
    SelectAttributes: {
      fill: "#5BBEF6",
      "fill-opacity": 0.5,
      stroke: "#5BBEF6",
      "stroke-width": 0.23,
      "stroke-linejoin": "round",
      "stroke-opacity": 1.0,
    }, */
  HighlightAttributes: {
    fill: '#Ffa500', //'#00F', //'#F4d7f4', //'#a4d7f4',
    "fill-opacity": 0.3,
    stroke: '#7B3804', //'#00F', // '#a4d7f4',
    'stroke-width': 2.5, //0.2,
    'stroke-linejoin': 'round',
    'stroke-opacity': 1.0,
  },
  SelectAttributes: {
    fill: '#F00', //'#5BFEF6', //'#5BBEF6',
    "fill-opacity": 0.3,
    stroke: '#5B0303', //'#5BBEF6',
    'stroke-linejoin': 'round',
    'stroke-width': 4, //0.23,
    'stroke-opacity': 1.0,
  },
  DefaultSpaceObjectAttributes: {   // test
    fill: '#3CB043',
    "fill-opacity": "0.3",      // fill opacity set to 0.1
    stroke: '#234F1E',
    'stroke-linejoin': 'round',
    'stroke-width': "0.2",
    'stroke-opacity': 1.0,
  },
  postFixServerToken: false,
  globalApplicationFilesLocation:
    "https://server.ai.cadviewer.com/content/custom/federalrealty.com/json/application/",
  //"http://localhost:3000/content/custom/federalrealty.com/json/application/",
  propertySVGFilesLocation:
    "https://server.ai.cadviewer.com/content/custom/federalrealty.com/svg/",
  //"http://localhost:3000/content/custom/federalrealty.com/svg/",
  propertyJSONFilesLocation:
    "https://server.ai.cadviewer.com/content/custom/federalrealty.com/json/property/",
  //"http://localhost:3000/content/custom/federalrealty.com/json/property/",
  // Default property to Load
  defautlPropertyToLoad: {
    propertyNumber: "", //"1627", //"2339", // set to undefined to disable default property
    planName: "", //"LP1", //"LP0", // set to undefined to disable default plan
  },
  enableQuickPdfPrint: true,
  chatResultDisplayMetrics: true, // Set to true to display metrics in the chat results
  propertyJSONFilesEnableDistance: true,
  propertyJSONFilesEnableLayerColors: true,
  topPaneScrollDownTitle: "Choose information plan/layer:", // set te title of the top pane scroll down menu
  displayTopPaneScrollDownButton: true, // display the top pane scroll down button, true to show the top pane scroll down menu
  topRowItem1: "Property Name:", // top row items
  topRowItem2: "Property Number:", // top row items
  topRowItem3: "Plan Name:", // top row items
  enableRightJSONModalPanel: true, // enabling JSON load right side pane for property selection
  enableRightFileModalPanel: false,  // enable right side panel for file selection
  setCADViewerSkin: "light-skin", //CADViewer Skin lightgray, black, deepblue, light-skin, dark-skin

  showLogoOnSideBarLeftPanel: true, // Set to true to display the logo on the side bar left panel
  cvjs_styleQTip_width: "320px", // set the width of the popup
  debugMode: true, // enables CADViewer debug traces in the browser
  enableHelperMethods: false,
  enableHelpersMethodsGroup_Highlight: false,
  enableHelpersMethodsGroup_Group: false,
  enableHelpersMethodsGroup_Manipulate: false,
  enableHelpersMethodsGroup_Insert: false,
  enableHelpersMethodsGroup_CustomCanvas: false,
  enableHelpersMethodsGroup_SpaceArea: false,
  enableHelpersMethodsGroup_RedlineArea: false,
  enableHelpersMethodsGroup_VizQueryDemo: false,
  enableHelpersMethodsGroup_Brookfield: false,
  enableHelpersMethodsGroup_UrbanEdge: false,
  enableHelpersMethodsGroup_UicEdu: false,
  enableHelpersMethodsGroup_Insuremep: false,

  enableAIAssistantPictureInPicture: true, // Set to true to enable the Pop Out functionality for the AI Assistant

  enableAIChat: false,
  useAIChatV5: true,
  useAIChatV4: false,

  aiChatV2Endpoint: "/ai/v2/chat", // Endpoint for the new AI chat service
  aiChatV3Endpoint: "/ai/v3/search-spaces", // Endpoint for the V3 AI chat service
  aiChatV4Endpoint: "http://localhost:8000/process-query-v4", // Endpoint for the V4 AI chat service
  aiChatV5Endpoint: "http://localhost:3000/ai/proxy", // Endpoint for the V5 proxy (supports snowflake and python)
  aiChatV5Provider: "python" as "snowflake" | "python" | "snowflake-agent", // Provider for the V5 proxy endpoint
  aiChatV5Mode: "Test" as "Test" | "Prod", // Mode for the V5 proxy endpoint (defaults to "Test")


  setBPLayerChange: true, // SET custom HEADER for BP Retail Layer Change  - 10.55.2
  customOnLoadEndContent: true, // custom OnLoadEnd content -processing of custom content in CADViewer.js

  customOnLoadEndContentUrbanEdge: true,


  defaultLayerColorsOnLoad: [
    // set the layer colors for BP Retail
    { layer: "0", color: "#000" },
    { layer: "UE_A-WALLS", color: "#000" },
    { layer: "UE_SITE-CURBS", color: "#000" },
    { layer: "UE_TNT-LEASE LINE", color: "#000" },
    { layer: "UE_A-DEMISNG WALL", color: "#000" },
    { layer: "UE_A-DOORS & GLAZING", color: "#000" },
  ],

  enableRightEmployeePanel: false,
  enableRightEmployeePanelText: "Employees",
  enableRightArchivePanel: false,
  enableRightArchivePanelText: "Archive",
  enableHelpButton1: false,
  helpbutton1: "Tech Docs",
  helpbutton1link: "https://cadviewer.com/cadviewertechdocs/",
  enableHelpButton2: false,
  helpbutton2: "User Manual",
  helpbutton2link: "https://cadviewer.com/cadviewerusermanual/",
  // Space Selection & Quick Actions Configuration
  enableSpaceTools: true, // Enable/disable space selection panel (works independently of AI Chat)
  spaceSelectionPosition: 'bottom-right', // Position of the space selection panel (changed from bottom-left to avoid conflict with DemoNavigation)
  enableQuickActions: true, // Enable/disable quick actions menu
  quickActionsConfig: {
    enableFinancialSummary: true, // Enable "Financial Summary" quick action
    enableOpportunityCost: true, // Enable "Opportunity Cost" quick action
  },
  enableBasicAuth: true,
  basicAuthUsername: "admin",
  basicAuthPassword: "dHB#s#wf6",


  popupCustomMenuNoDataSet: "No Data Set Provided from Salesforce", // custom menu for no data set
  popupCustomMenuNoDataSetIcon: "fa fa-times", // custom menu for no data set icon


  aiBaseQueries: [
    // 1 future tenant on Willowbrook LP1 vs 171 across the portfolio.
    { text: "Which stores has a future tenant? list current and future tenants", scope: "global" },
    { text: "How many malls are in the portfolio, list them with decreasing number of stores, include the state", scope: "global" },
    // Proximity reads the DISTANCES table, which is stored per plan. Apple is on
    // Willowbrook LP1 (space 1585); Lululemon, used previously, is not there at all.
    { text: "I need all stores within 110 feet from Apple with lease expiration before 2027", scope: "current" },
    { text: "Which tenants who are below their average square footage size over all malls by 10% or more and above their average total sales by 10% or more", scope: "global" },
    // Adjacency is also per plan.
    { text: "Find adjacent vacant or expiring spaces within the next 6 months that could be combined", scope: "current" },
    { text: "Provide the best options to combine adjacent spaces between 7,000 - 12,000 SF based on total rent and lease expiration", scope: "current" },
    { text: "Analyze all lease plans in the portfolio and recommend a prospective tenant for Space 1485 based on the size of the space and frequent co-tenants within 200 feet of the store-front", scope: "global" }
  ],



  // Button Colors Configuration
  // These values override the CSS defaults in index.css
  // You can customize button colors per-demo by setting this in demo config files
  // Or at runtime by loading from an external JSON file
  buttonColors: {
    // Primary buttons (dark blue) - used for main action buttons in the header
    primary: {
      bg: "#262626", //"#013429",  // #013429 - GGP GREEN    "#0d304f" Brookfield
      bgHover: "#262626", //"#013429", // #013429 - GGP GREEN    "#0f3557" Brookfield
      text: "#ffffff",
      ring: "#262626", //"#013429", // #013429 - GGP GREEN    "#0f3557" Brookfield
    },
    // Accent buttons (orange gradient) - used for AI chat button
    accent: {
      bg: "#f97316",
      bgHover: "#ea580c",
      text: "#ffffff",
      gradientFrom: "#fb923c",
      gradientTo: "#c2410c",
      ring: "#f97316",
    },
    // FAB (Floating Action Buttons) - used for space tools button
    fab: {
      bg: "#0f3557",
      bgHover: "#0d304f",
      text: "#ffffff",
      ring: "#0f3557",
    },
    // Subtle/secondary buttons - used for switch plan button
    subtle: {
      bg: "#fed7aa",
      bgHover: "#fdba74",
      text: "#c2410c",
    },
  },

  primaryColors: {
    50: "#e2e7eb",
    100: "#b7c2cd",
    200: "#879aab",
    300: "#577289",
    400: "#335370",
    500: "#262626", //"#013429",    // Brookfield #0f3557  GGP "#013429"
    600: "#262626", //"#013429",    // Brookfield #0d304f  GGP "#013429"
    700: "#262626", //"#013429",    // Brookfield #0b2846  GGP "#013429"
    800: "#262626", //"#013429",    // Brookfield #08223c  GGP "#013429"
    900: "#262626", //"#013429",    // Brookfield #04162c  GGP "#013429"
  },

  // Theme Colors Configuration
  // Override sidebar, panel, and layout colors independently from primary palette
  // If not set, sidebar/panel colors derive from the primary palette via CSS variables
  themeColors: {
    sidebarBackground: "#262626", //"#013429", // GGP "#013429", // Brookfield "#0f3557",  // defaults to var(--primary-500)
    // sidebarHamburgerBackground: "#0f3557",
    // sidebarTitle: "#f9f9f9",
    // sidebarSubtitle: "#efeff0",
    // bottomPanelBackground: "#ffffff",
    // rightActionBackground: "#0f3557",
  },
  accordionGroups: {
    "Tenant Overview": [
      "Tenant_Trade",
      "Tenant_Legal",
      "DBA_Name",
      "JDE_Tenant_Name",
      "Tenant_JDE_No",
      "Account_Name",
      "Sales_Category_DBA",
      "Mid_Major_Category",
      "Anchor_Status_Lease",
      "PARENT_ACCOUNT",
      "Subdivision"],
    "Tenant & Space Info": [
      "GLA",
      "Usable SF",
      "Lease Start",
      "Lease End",
      "Occupancy Status",
      "Lease_Id",
      "Lease_Desc",
      "Lease_SRCCD",
      "Lease_Status",
      "Lease_Type",
      "Business_Unit_No",
      "Site_Code",
      "Unit_Code",
      "Unit_Type",
      "Line",
      "Display_Unit",
      "Effective_Beg",
      "Effective_End",
      "Original_Lease_End_Date",
      "Renewal_Date",
      "Move_In_Date",
      "Move_Out_Date",
      "Open_Date",
      "Close_Date",
      "Close_Reason",
      "Execution_Date",
      "Rent_Start_Date"
    ],
    "Lease Financials": [
      "Min_Rent_Annual",
      "Min_Rent_Monthly",
      "Total_Annual_Rent",
      "PSF_RENT",
      "PSF_RENT_FINAL",
      "PSF_CAM",
      "PSF_Tax",
      "PSF_Marketing",
      "Total_PSF",
      "TTM_Total_Rent",
      "TTM_Total_Rent_PSF",
      "Current_Monthly_Rents",
      "Occupancy_Cost_Ratio",
      "Occupancy_Cost",
      "Leased_Area",
      "Actual_Rentable_Area",
      "Unit_Begin_SF"
    ],
    "Sales Performance": [
      "SALES_TTM",
      "Sales_PSF",
      "Sales_Last_Reported",
      "Sales_TTM_of_Months"
    ],
    "Unit Info": [
      "UNIT_ID",
      "UNIT_CODE",
      "UNIT_DESC",
      "UNIT_DESC2",
      "UNIT_DESC3",
      "UNIT_DESC4",
      "UNIT_DESC5",
      "UNIT_NAME",
      "UNIT_GLA",
      "UNIT_USEABLESF",
      "UNIT_RENT",
      "UNIT_TYPE_DESC",
      "UNIT_TYPE_SRCCD",
      "UNIT_USE_DESC",
      "UNIT_USE_SRCCD",
      "DISPLAY_UNIT",
      "FLOOR",
      "ANCHOR_FLAG",
      "Occupancy_Status",
      "BU_PROPIDEX_SRCCD",
      "BU_SITE_SRCCD",
      "BU_NO",
      "PROPIDEX_UNIT",
      "BUD_RENT_PSF",
      "Budget_Comm_PSF",
      "Budget_TI_PSF",
      "UNIT_DESC3",
      "UNIT_DESC4",
      "UNIT_DESC5",
      "UNIT_NAME",
      "UNIT_GLA",
      "UNIT_USEABLESF",
      "UNIT_RENT",
      "UNIT_TYPE_DESC",
      "UNIT_TYPE_SRCCD",
      "UNIT_USE_DESC",
      "UNIT_USE_SRCCD",
      "DISPLAY_UNIT",
      "FLOOR",
      "ANCHOR_FLAG",
      "Occupancy_Status",
      "BU_PROPIDEX_SRCCD",
      "BU_SITE_SRCCD",
      "BU_NO",
      "PROPIDEX_UNIT",
      "BUD_RENT_PSF",
      "Budget_Comm_PSF",
      "Budget_TI_PSF"
    ],
    Overview: [
      "Renewal_Status",
      "Ownership_Entity",
      "Site_Name",
      "Notice_Address",
      "Store_Address",
      "Address_Notice",
      "AR_Balance",
      "AR_Balance_Total",
      "AR_Balance_Deferred",
      "BU_PROPIDEX_SRCCD",
      "BU_SITE_SRCCD",
      "BU_NO",
      "PROPIDEX_UNIT",
      "BUD_RENT_PSF",
      "Budget_Comm_PSF",
      "Budget_TI_PSF"
    ],
    Others: [], // Will be populated with the rest of the keys
  },
  ShowInformativeBottomPanel: true, // turn the the bottom panel on off
  ShowInformativeBottomPanelWhenClickInLeftPanel: true,
  ShowInformativeLeftPanel: false, // initia show the left side panel
  bottomPaneSliderMode: "aboveCADViewer", // withCADViewer, aboveCADViewer,
  bottomPaneDefaultHeight: 15, // (15)   percentage of screen height (2) min
  rightPanelDefaultWidth: 36, // (40) percentage of screen height
  leftPaneDefaultWidth: 17, // (17) percentage of screen height


};

export default federalRealtyConfig;
